import {Component, Input} from '@angular/core';
import {Notification} from '../../../state/notification';
import {CurrentUser} from '../../../../user/current-user.service';

@Component({
  selector: 'app-localized-raw-title',
  templateUrl: './localized-raw-title.component.html',
  styleUrls: ['./localized-raw-title.component.scss']
})
export class LocalizedRawTitleComponent {

  @Input()
    notification: Notification;

  constructor(public currentUser: CurrentUser) {
  }

}
